import { c } from 'ttag';

import { refusalCode } from '../../graphql/refusalCode';
import { Refusal } from '../accounts/portalAccess';

/**
 * Reading of the refusals `setUserPartnerList` answers with. The wording is ours.
 *
 * `FORBIDDEN_OUT_OF_SCOPE` covers all of the person's accounts, not one: the list hangs
 * from the person, so the gesture needs `manage_users` on every account they hold.
 */
export const partnerListRefusalOf = (error: unknown): Refusal => {
    switch (refusalCode(error)) {
        case 'MISSING_PERMISSION':
            return {
                title: c('Partner list refusal').t`Your role does not let you manage users.`,
                guidance: c('Partner list refusal')
                    .t`Attributing a partner list is a user-administration act. Ask an administrator, or have your role widened.`,
            };
        case 'FORBIDDEN_OUT_OF_SCOPE':
            return {
                title: c('Partner list refusal').t`This person reaches beyond your portfolio.`,
                guidance: c('Partner list refusal')
                    .t`Their list belongs to the person, so changing it needs the right to manage users on every account they hold, and at least one is outside what you may manage. Someone with the wider perimeter must do it.`,
            };
        case 'PARTNER_LIST_NOT_FOUND':
            return {
                title: c('Partner list refusal').t`This list is no longer available.`,
                guidance: c('Partner list refusal')
                    .t`It was archived or removed from the catalogue since this dialog opened. Close it and reopen it to pick from the lists that remain.`,
            };
        case 'USER_NOT_FOUND':
            return {
                title: c('Partner list refusal').t`This person no longer exists.`,
                guidance: c('Partner list refusal')
                    .t`They may have just been deleted. Go back to the list to read it as it stands.`,
            };
        default:
            return {
                title: c('Partner list refusal').t`The partner list could not be changed.`,
                guidance: c('Partner list refusal')
                    .t`Nothing was changed. If it keeps refusing, pass the sentence below on to your Freelance.com contact.`,
            };
    }
};
